const storeRedirectURIInLocalStorage = (redirectURI) => {
  localStorage.setItem('anova_redirect_uri', redirectURI)
}

export default storeRedirectURIInLocalStorage
